import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class BasicAutoQueryController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    const queries = this.getQueries();
    $ctrl.$queries = {};
    for (const queryName in queries) {
      //console.debug(queryName, queries[queryName]);
      if (queries[queryName]) {
        $ctrl.$queries[queryName] = $ctrl[queryName] = new AutoQuery(
          queries[queryName]
        );
        if (!$ctrl.bus) $ctrl.bus = $ctrl[queryName].bus;
      }
    }
  }
  getQueries() {
    return {
      query: this.getQuery(),
    };
  }
  getQuery() {
    return {
      autoLoad: false,
      disableQueryString: true,
      hideLeftNav: true,
    };
  }
  load() {
    return Object.values(this.$queries).forEach((q) => q.load());
  }
  $cleanUp() {
    return Object.values(this.$queries).forEach((q) => q.dispose());
  }
}
